<template>
  <div class="hearder-box">
    <div class="project-system-header">
      <div class="project-system-left">{{`${orgName}—${projectName}`}}</div>
      <div class="project-system-right">
        <!-- <div class="system-left">{{projectName}}</div> -->
        <div class="exit-personal-inquiry" @click="toLoginOut" v-if="isShow">退出个人查询</div>
        <div class="system-right" @click="goBack">{{backName}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { setSession, getSession, removeSession } from '@/untils';
import { logoutHouseholdIndex } from '@/api/publicinquiry.api.js';
import Cookies from 'js-cookie';
export default {
  name: 'Heater',
  props: {
    backName: {
      type: String,
      default: '返回项目列表'
    },
    backPath: {
      type: String,
      default: 'projectlist'
    }
  },
  computed: {},
  data() {
    return {
      orgName: '',
      projectName: '',
      projectId: '',
      isLoginOut: '',
      isShow: false
    };
  },
  methods: {
    goBack() {
      if (this.backPath === 'projectlist') {
        logoutHouseholdIndex(this.projectId).then(res => {
          if (res.code === 0) {
            removeSession('token');
            removeSession('session');
            removeSession('selectFlag');
            removeSession('tierBuildingHouseIds');
            removeSession('highBuildingHouseIds');
            removeSession('userInfo');
            Cookies.remove('token');
            Cookies.remove('yz_session_id');
          }
        });
        // removeSession('token');
        // removeSession('session');
        // Cookies.remove('token');
        // Cookies.remove('yz_session_id');
      }
      this.$router.push({ name: this.backPath });
    },
    toLoginOut() {
      this.$confirm('确定要退出个人查询么?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logoutHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              removeSession('token');
              removeSession('session');
              removeSession('selectFlag');
              removeSession('tierBuildingHouseIds');
              removeSession('highBuildingHouseIds');
              removeSession('userInfo');
              Cookies.remove('token');
              Cookies.remove('yz_session_id');
            }
          });
          this.isShow = false;
          // this.isLoginOut = 'undefined';
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    }
  },
  created() {
    this.orgName = getSession('newOrgName');
    this.projectName = getSession('projectName');
    this.projectId = getSession('projectId');
    this.isLoginOut = Cookies.get('token');
    if (this.isLoginOut) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
};
</script>
<style scoped>
.project-system-header {
  height: 40px;
  border-bottom: 1px solid rgb(2, 91, 145);
}
.project-system-left {
  float: left;
  padding: 5px 0;
  text-indent: 15px;
  color: #025b91;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
}
.project-system-right {
  float: right;
  display: flex;
}
.system-left {
  padding: 5px 150px;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #1e1e1e;
}
.exit-personal-inquiry {
  width: 110px;
  height: 30px;
  line-height: 30px;
  background-color: rgba(2, 91, 145, 1);
  font-size: 14px;
  color: #ffffff;
  border-radius: 5px;
  text-align: center;
  margin-right: 15px;
}
.system-right {
  height: 30px;
  width: 110px;
  text-align: center;
  line-height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue